class ExportAuditTrail {
	constructor(
		public readonly accountId: number,
		// Always carries exactly two `occurredBetween` entries: the export endpoint requires the
		// period, unlike the list endpoint where it is optional.
		public readonly queryParams: URLSearchParams,
	) {
		Object.freeze(this);
	}

	toQueryString(): string {
		return this.queryParams.toString();
	}

	/**
	 * Composed client-side from the requested period, ASCII only, no accent, no whitespace — the
	 * only shape `Domain/Api.ts` can parse out of `Content-Disposition`. It is the last resort, not
	 * a formality: a credentialed CORS response only exposes a header listed in `exposedHeaders`,
	 * and no test in this repository — neither MSW nor supertest — simulates CORS, so a regression
	 * on the server's `exposedHeaders` line would go undetected without this fallback.
	 */
	get fallbackFilename(): string {
		const [start, end] = this.queryParams.getAll('occurredBetween');
		const startDate = start?.slice(0, 10) ?? 'periode';
		const endDate = end?.slice(0, 10) ?? 'inconnue';

		return `journal-audit-${startDate}-${endDate}.csv`;
	}
}

export default ExportAuditTrail;
